import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {
  @Output() confirm = new EventEmitter<void>();

  constructor(public ngbModal: NgbActiveModal) { }

  ngOnInit(): void {
  }
  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  confirmAction() {
    this.confirm.emit(); // Emit event when user confirms
    this.ngbModal.close('Files Confirmed');
  }
}
